import { render, staticRenderFns } from "./product-setting-table.vue?vue&type=template&id=7ac8b1e8&scoped=true&"
import script from "./product-setting-table.vue?vue&type=script&lang=js&"
export * from "./product-setting-table.vue?vue&type=script&lang=js&"
import style0 from "./product-setting-table.vue?vue&type=style&index=0&id=7ac8b1e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8b1e8",
  null
  
)

export default component.exports